import { Identifiable, List, Project, Task } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { LinkedList, LinkedResource, Linker } from "../linkers/types";

type Activity = LinkedList & {
  subActivities: LinkedResource<Identifiable<Activity>>[];
};

type Response = LinkedList & {
  activities: Activity[];
};

function renameActivities(activities: Identifiable<Activity>[]): LinkedList[] {
  return activities.map((activity) => ({
    ...activity,
    subLists: renameActivities(activity.subActivities),
  }));
}

function extractTasks(list: Identifiable<List>): Identifiable<Task>[] {
  return [
    ...list.tasks,
    ...list.subLists.reduce<Identifiable<Task>[]>(
      (tasks, subList) => [...tasks, ...extractTasks(subList)],
      [],
    ),
  ];
}

function getProjectTasks(httpClient: HttpClient, linker: Linker) {
  return ({ uuid }: Identifiable<Project>) =>
    httpClient
      .sendHttpRequest<Response>({
        endpoint: `/projects/${uuid}?projection=gantt&embed_links=false`,
        method: HttpMethods.GET,
      })
      .then((project) => {
        const [rootList] = renameActivities(project.activities);

        return rootList ? linker.linkList(rootList) : Promise.reject();
      })
      .then(extractTasks);
}

export { getProjectTasks };
